import React from 'react';

import LoadDocBtn from '../../modules/load-doc-btn';
import Notice from '../../modules/notice/notice';
import TableDoc from '../../modules/table-doc/table-doc';
import TableWrapper from '../../modules/table-wrapper/table-wrapper';
import { ORDER_DETAILED_STATUS, SORT_DIRECTION } from '../../types';

import OrderRealizationsAdjustedFooter from './order-realizations-adjusted-footer/order-realizations-adjusted-footer';
import OrderRealizationsAdjustedList from './order-realizations-adjusted-list/order-realizations-adjusted-list';
import OrderRealizationsAdjustedSorts from './order-realizations-adjusted-sorts/order-realizations-adjusted-sorts';
import OrderRealizationsHeader from './order-realizations-header/order-realizations-header';

import './order-realizations-adjusted.scss';

interface OrderRealizationsAdjustedProps {
  data: {
    oldCount: number;
    count: number | null;
    oldSum: number;
    sum: number | null;
    title: string;
  }[];
  directions: {
    sum: SORT_DIRECTION;
    oldSum: SORT_DIRECTION;
    count: SORT_DIRECTION;
    oldCount: SORT_DIRECTION;
  };
  onToggleSort: (
    name: 'oldCount' | 'count' | 'sum' | 'oldSum',
    direction: SORT_DIRECTION
  ) => void;
  onSubmit: () => void;
  type: 'matching' | 'payment' | 'waiting';
  totalChangedSum: number;
  status?: ORDER_DETAILED_STATUS;
  balanceError?: boolean;
  orderRef: string;
  adjustmentComment?: string;
}

const OrderRealizationsAdjusted: React.FC<OrderRealizationsAdjustedProps> = ({
  data,
  orderRef,
  adjustmentComment,
  balanceError,
  status,
  type,
  totalChangedSum,
  onSubmit,
  directions,
  onToggleSort,
}) => {
  const getChangedPositions = () =>
    data.filter((position) => position.sum !== null || position.count !== null);

  return (
    <TableWrapper>
      <div className="realization-adjust">
        <div className="realization-adjust__header">
          {status && (
            <OrderRealizationsHeader
              showStatus
              status={status}
              title={orderRef}
            />
          )}
          <TableDoc
            docs={[<LoadDocBtn title="Test.pdf" onSpecDownload={() => {}} />]}
            title="Документы реализации"
          />
          {adjustmentComment && (
            <div className="realization-adjust__notice">
              <Notice prefix="Комментарий" text={adjustmentComment} />
            </div>
          )}
        </div>
        <OrderRealizationsAdjustedSorts
          directions={directions}
          onItemToggle={onToggleSort}
        />
        <div className="realization-adjust__body">
          <OrderRealizationsAdjustedList data={data} />
        </div>
        <OrderRealizationsAdjustedFooter
          balanceError={balanceError}
          onSubmit={onSubmit}
          type={type}
          positionsCount={getChangedPositions()?.length}
          sum={totalChangedSum}
        />
      </div>
    </TableWrapper>
  );
};

export default OrderRealizationsAdjusted;
